import packageJson from '../../package.json';

export const logBuildInfo = () => {
  const commitShortSha = import.meta.env.VITE_COMMIT_SHORT_SHA || 'unknown';
  const buildTimestamp = import.meta.env.VITE_BUILD_TIMESTAMP || '';
  const formattedTimestamp = buildTimestamp ? new Date(buildTimestamp).toISOString() : 'unknown';
  const ibsysKitVersion =
    packageJson.dependencies?.['@ibsys/kit'] ?? packageJson.dependencies?.['@ibsys/kit'] ?? 'unknown';

  console.groupCollapsed('Build info');
  console.log('Commit:', commitShortSha);
  console.log('Build time:', formattedTimestamp);
  console.log('@ibsys/kit:', ibsysKitVersion);
  console.groupCollapsed('env');
  Object.entries(import.meta.env).forEach(([key, value]) => {
    if (key.startsWith('VITE_')) {
      console.log(key, value);
    }
  });
  console.groupEnd();
  console.groupEnd();
};
